import { IRoute, LayoutsMap, RoutesMap } from './router.types.ts';

export const routesModel = {
  [RoutesMap.WELCOME]: {
    id: RoutesMap.WELCOME,
    name: 'welcome',
    path: '/welcome',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.PERSONAL_DETAILS]: {
    id: RoutesMap.PERSONAL_DETAILS,
    name: 'Contact',
    path: '/personal-details',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.PHONE]: {
    id: RoutesMap.PHONE,
    name: 'Phone Number',
    path: '/phone',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.IDENTITY]: {
    id: RoutesMap.IDENTITY,
    name: 'Identity',
    path: '/identity',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.HOME_ADDRESS]: {
    id: RoutesMap.HOME_ADDRESS,
    name: 'Home Address',
    path: '/home-address',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.PLAN_SELECTION]: {
    id: RoutesMap.PLAN_SELECTION,
    name: 'Choose a Plan',
    path: '/plan-selection',
    layoutType: LayoutsMap.BASIC,
  },
  [RoutesMap.KNOW_YOUR_BUSINESS]: {
    id: RoutesMap.KNOW_YOUR_BUSINESS,
    groupId: 'Business Details',
    name: 'Know your business',
    path: '/know-your-business',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.BUSINESS_ADDRESS]: {
    id: RoutesMap.BUSINESS_ADDRESS,
    groupId: 'Business Details',
    name: 'Business address',
    path: '/business-address',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.INDUSTRY]: {
    id: RoutesMap.INDUSTRY,
    groupId: 'Business Details',
    name: 'Business industry',
    path: '/industry',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.BUSINESS_TYPE_SELECTION]: {
    id: RoutesMap.BUSINESS_TYPE_SELECTION,
    groupId: 'Business Details',
    name: 'Business type selection',
    path: '/business-type',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.ADD_OWNER]: {
    id: RoutesMap.ADD_OWNER,
    name: 'Add Owner',
    path: '/add-owner',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.REVIEW]: {
    id: RoutesMap.REVIEW,
    name: 'Confirmation',
    path: '/review-details',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.KYB_PENDING]: {
    id: RoutesMap.KYB_PENDING,
    name: 'KYB Pending',
    path: '/kyb-pending',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.VERIFICATION_CENTER]: {
    id: RoutesMap.VERIFICATION_CENTER,
    name: 'Verification Center',
    path: '/verification-center',
    layoutType: LayoutsMap.DEFAULT,
  },

  [RoutesMap.SUCCESS]: {
    id: RoutesMap.SUCCESS,
    name: 'Success',
    path: '/success',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.FAILD_UPLOAD]: {
    id: RoutesMap.FAILD_UPLOAD,
    name: 'Failed Upload',
    path: '/failed-upload',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.DEBIT_CARD_NAME]: {
    id: RoutesMap.DEBIT_CARD_NAME,
    name: 'Debit Card Name',
    path: '/debit-card-name',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.OWNER_CENTER]: {
    id: RoutesMap.OWNER_CENTER,
    name: 'Owners Center',
    path: '/owners-center',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.GENERIC_MESSAGE_PAGE]: {
    id: RoutesMap.GENERIC_MESSAGE_PAGE,
    name: 'Generic Message Page',
    path: '/generic-message',
    layoutType: LayoutsMap.EDGE_CASE,
  },
  [RoutesMap.SOCURE_DOC_V]: {
    id: RoutesMap.SOCURE_DOC_V,
    name: 'One last step',
    path: '/socure-doc-v',
    layoutType: LayoutsMap.EDGE_CASE,
  },
  [RoutesMap.UNDER_REVIEW]: {
    id: RoutesMap.UNDER_REVIEW,
    name: 'Under Review',
    path: '/under-review',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.ACCOUNT_OPENING_REASON]: {
    id: RoutesMap.ACCOUNT_OPENING_REASON,
    name: 'Account Opening Reason',
    groupId: 'Business Details',
    layoutType: LayoutsMap.HAPPY_FLOW,
    path: '/account-opening-reason',
  },
  [RoutesMap.INVITE_TEAM_MEMBER_INTRO]: {
    id: RoutesMap.INVITE_TEAM_MEMBER_INTRO,
    name: 'Invite Team Member Intro',
    path: '/invite-team-member-intro',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.INVITE_ACCOUNTANT_FORM]: {
    id: RoutesMap.INVITE_ACCOUNTANT_FORM,
    name: 'Personal Details',
    groupId: 'Personal Details',
    path: '/accountant-personal-details',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.VERIFY_PHONE_NUMBER]: {
    id: RoutesMap.VERIFY_PHONE_NUMBER,
    name: 'Verify Phone',
    path: '/verify-phone-number',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.SET_PASSWORD]: {
    id: RoutesMap.SET_PASSWORD,
    name: 'Create Password',
    path: '/set-password',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
  [RoutesMap.INVITE_TEAM_MEMBER_FINISHED]: {
    id: RoutesMap.INVITE_TEAM_MEMBER_FINISHED,
    name: 'Invite Team Member Success',
    path: '/invite-team-member-finished',
    layoutType: LayoutsMap.DEFAULT,
  },
  [RoutesMap.INVITE_ADMIN_FORM]: {
    id: RoutesMap.INVITE_ADMIN_FORM,
    name: 'Personal details',
    path: '/admin-personal-details',
    layoutType: LayoutsMap.HAPPY_FLOW,
  },
} as const satisfies Record<RoutesMap, IRoute>;

export type RoutesModel = typeof routesModel;

//TODO: verify if this needs to be 0 or -1
export const DEFAULT_PAGE_INDEX = 0;

export const getRouteByPath = (path: string): IRoute | undefined => {
  return Object.values(routesModel).find((route) => route.path === path);
};
